module.exports = __webpack_public_path__ + "img/logo1.d658f15c.svg";